import Form from 'react-bootstrap/Form';

function ReportsMineOnlyForm({ mineOnly, toggleMineOnly }) {
  return (
    <>
      <Form.Check
        className="ms-3 bo-checkbox"
        name="mineOnly"
        id="mineOnly"
        checked={mineOnly === 'TRUE'}
        onChange={() => toggleMineOnly('reports')}
      />
      <Form.Label className="p-0 mt-1 mb-0 me-0">Show my reports only</Form.Label>
    </>
  );
}

export default ReportsMineOnlyForm;
